import { COLUMNS, formatPricing } from '@/lib/b2bPricing';

export const PricingResults = ({ values }) => (
  <section className="b2b-results" aria-labelledby="b2b-results-title">
    <h2 id="b2b-results-title" className="mb-3 text-base font-semibold">Calculated outputs</h2>
    <dl className="divide-y divide-cyan-900/10">
      {COLUMNS.filter(c => c.formula).map(column => (
        <div key={column.key} className="flex items-start justify-between gap-3 py-2.5">
          <dt className="max-w-[65%] text-xs text-zinc-600" title={column.formula}>{column.label}</dt>
          <dd data-testid={`b2b-output-${column.key}`} className={`break-all text-right font-mono text-sm font-medium ${['actual_margin_pct', 'actual_margin_amount'].includes(column.key) && values[column.key] < 0 ? 'text-rose-700' : 'text-cyan-900'}`}>
            {formatPricing(values[column.key], column)}
          </dd>
        </div>
      ))}
    </dl>
  </section>
);